import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import allPages from 'global/page';
import { useLoginService } from 'service/login';

const initState = {
    idToken: ''
};

const StaffContext = createContext(initState);
export const useStaffContext = () => useContext(StaffContext);

export const StaffProvider = ({ children }) => {
    const [idToken, setIdToken] = useState(initState.idToken);
    const [pages, setPages] = useState(allPages);
    const { getIsTokenValid, storageKeys } = useLoginService();

    // 為了防止多次打 instance.acquireTokenSilent Api 而使用的鎖
    const isRefreshing = useRef(false);
    const refreshPromise = useRef(null);

    const logout = useCallback(() => {
        setIdToken('');
        sessionStorage.removeItem(storageKeys.idToken);
        sessionStorage.removeItem(storageKeys.city);
    }, [storageKeys.city, storageKeys.idToken]);

    const getIdToken = useCallback(async (args) => {
        const callback = async () => {
            // 可能其他支 Api 正在 refresh token，所以直接 return 同一個 Promise 的結果
            if (isRefreshing.current) {
                return refreshPromise.current;
            }
            
            isRefreshing.current = true;
            // eslint-disable-next-line no-async-promise-executor, consistent-return
            refreshPromise.current = new Promise(async (resolve, reject) => {
                try {
                    const storedIdToken = sessionStorage.getItem(storageKeys.idToken);
                    const isTokenValid = getIsTokenValid(storedIdToken);
                    if (isTokenValid) {
                        setIdToken(storedIdToken);
                        resolve(storedIdToken);
                        return;
                    }
                } catch(err) {
                    reject(err);
                } finally {
                    isRefreshing.current = false;
                }
            });

            return refreshPromise.current;
        };

        const callbackResult = await callback(args);
        return callbackResult;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const getIdTokenFunc = async () => {
            try {
                await getIdToken();
            } catch(msg) {
                alert(msg);
                window.location.reload();
            }
        }

        getIdTokenFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <StaffContext.Provider
            value={{
                idToken,
                pages,
                setPages,
                getIdToken,
                setIdToken,
                logout
            }}
        >
            {children}
        </StaffContext.Provider>
    );
};
